import { useEffectEvent } from "@faire/web--source/ui/hooks/useEffectEvent";
import { trackProductTileHeartClick } from "@faire/web-api--source/events/productTile/click/heart";
import { IProduct } from "@faire/web-api--source/indigofair/data/IProduct";

import { getPromotedByString } from "@faire/retailer/hooks/ProductTileImpression/__internal__/getPromotedByString";
import { useProductTileClickImpressionContext } from "@faire/retailer/hooks/ProductTileImpression/useProductTileClickImpressionContext";

export const useRecordHeartClickEvent = (
  token: string | undefined,
  impressionId: string | undefined,
  promotedBy: Array<keyof typeof IProduct.PromotedType> | undefined,
  recordImpressions = false
) => {
  const {
    context,
    requestId,
    containerContext,
    screenContext,
    contextToken: contextToken,
  } = useProductTileClickImpressionContext();

  return useEffectEvent(() => {
    if (!token || !recordImpressions) {
      return;
    }

    const eventPromotedByString = getPromotedByString(promotedBy);
    trackProductTileHeartClick(
      context,
      requestId ?? "",
      token,
      eventPromotedByString,
      impressionId ?? "",
      screenContext,
      containerContext,
      contextToken
    );
  });
};
